import {
  baseResource,
  createResource,
  postResource,
  optionsResource,
  patchResource,
} from '@resource/resource'
import { prefixAPI } from '@resource/api'

import { friendlyUrlGenerator } from '@utils/friendly'

const MODEL_PREFIX = 'catalog'

export const ANNOUNCEMENT_CREATE = prefixAPI('/create/', MODEL_PREFIX)
export const ANNOUNCEMENT_RETRIEVE = prefixAPI('/{id}/retrieve-update/', MODEL_PREFIX)
export const ANNOUNCEMENT_LIST = prefixAPI('/list/{;filters*}{?limit,offset}', MODEL_PREFIX)
export const ANNOUNCEMENT_SEARCH = prefixAPI('/search/{?query}', MODEL_PREFIX)
export const ELEVATOR_DATA = prefixAPI('catalog/elevator/{label}/retrieve/')
const PRODUCTS_LIST_URL_PREFIX = prefixAPI('catalog/elevator/list')
const PRODUCTS_LIST_URL_POSTFIX = ''

const order = {
  path: [
    'prefix',
    'label',
    'postfix',
  ],
  query: [
    'query',
  ],
}

export const announcementMapListResource = friendlyUrlGenerator(
  [PRODUCTS_LIST_URL_PREFIX, PRODUCTS_LIST_URL_POSTFIX], baseResource, order
)

export const ANNOUNCEMENT_MAP_LIST = prefixAPI('/elevator/list/{;filters*}', MODEL_PREFIX)

export const announcementCreateResource = createResource(ANNOUNCEMENT_CREATE, postResource)
export const announcementRetrieveResource = createResource(ANNOUNCEMENT_RETRIEVE)
export const announcementUpdateResource = createResource(ANNOUNCEMENT_RETRIEVE, patchResource)
export const announcementListResource = createResource(ANNOUNCEMENT_LIST)
export const announcementSearchResource = createResource(ANNOUNCEMENT_SEARCH)
export const elevatorData = createResource(ELEVATOR_DATA)

// export const announcementMapListResource = createResource(ANNOUNCEMENT_MAP_LIST)
export const announcementOptionsResource = createResource(ANNOUNCEMENT_MAP_LIST, optionsResource)
